<template lang="pug">
  .div
    .columns
      .column.is-12.has-text-centered
        FormDesglose(v-for="(i, index) in items" :item="i" :key="i.id" :index='index' :itemsRequisicion="itemsRequisicion" :baseArticulos="baseArticulos" @itemSaved='itemSaved' @itemUpdate='itemUpdate')
    .columns(v-show="parseInt(total) > 0")
      .column.is-offset-8.is-2
        span Total
      .column.is-2
        span.tag.is-black
          | {{ total | currency}}
</template>

<script>
  import FormDesglose from './FormDesglose.vue'
  export default {
    name: 'ListItemsDesglose',
    components: { FormDesglose, },
    props: {
      items: {
        type: Array,
        default: () => []
      },
      baseArticulos: {
        type: Array,
        default: () => []
      },
      itemsRequisicion: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        total: 0.00,
        itemsSaved: [],
        dataForm: {}
      }
    },
    watch: {
      itemsSaved() {
        this.total = 0
        this.itemsSaved.map(item => {
          console.log(item)
          this.total = this.total + item.importe
          console.log(this.total)
        })
        
        console.log(this.total)
        this.$emit('itemsChanged', this.itemsSaved)
      }
    },
    methods: {
      itemSaved(item) {
        this.itemsSaved.push(item)
      },
      itemUpdate(val) {
        this.itemsSaved[val.index] = val
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/requisiciones_Componentes/ListItemsDesglose.vue